/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { oAuthCredentialStatusSchema } from './oAuthCredentialStatusSchema';

export const oAuthCredentialStatusResponseSchema = z.object({
  get statuses() {
    return z.array(oAuthCredentialStatusSchema);
  },
});
